let cn = {
    FINDPASS: "重置密码",
    VERACC: "验证账号",
    MODPASS: "修改密码",
    RESCOMP: "重置完成",
    VERCODE: "验证码",
    SEENOTCLEAR: "看不清？",
    CHANGEIMGCODE: "换一张",
    PHONECODE: "手机校验码",
    NEWPASS: "新密码",
    REPNEWPASS: "重复新密码",
    NEXTSTEP: "下一步",
    MODSUCCESSMSG: "密码已重置，请牢记新密码！",
    MODSUCCESSMSGJUMPMSG: "秒后跳转到",
    LOGINPAGE: "登录页",
    VERIFY: '验 证',
    BACK: "返回",

};
let tw = {
    FINDPASS: "重置密碼",
    VERACC: "驗證賬號",
    MODPASS: "修改密碼",
    RESCOMP: "重置完成",
    VERCODE: "驗證碼",
    SEENOTCLEAR: "看不清？",
    CHANGEIMGCODE: "換一張",
    PHONECODE: "手機校驗碼",
    NEWPASS: "新密碼",
    REPNEWPASS: "重複新密碼",
    NEXTSTEP: "下一步",
    MODSUCCESSMSG: "密碼已重置，請牢記新密碼！",
    MODSUCCESSMSGJUMPMSG: "秒後跳轉到",
    LOGINPAGE: "登錄頁",
    VERIFY: "驗 證",
    BACK: "返回",
};
let en = {
    FINDPASS: 'Reset Password',
    VERACC: 'Verify Account',
    MODPASS: 'Change Password',
    RESCOMP: 'Reset Completed',
    VERCODE: 'Image Code',
    SEENOTCLEAR: "Can't See?",
    CHANGEIMGCODE: 'Change One',
    PHONECODE: 'Verification Code',
    NEWPASS: 'New Password',
    REPNEWPASS: 'Repeat New Password',
    NEXTSTEP: 'Next',
    MODSUCCESSMSG: 'The password has been reset, please remember the new password!',
    MODSUCCESSMSGJUMPMSG: ' Second, Jump to',
    LOGINPAGE: 'Login Page',
    VERIFY: 'Validation',
    BACK: "Back",
}

export {
    cn,
    tw,
    en
}